var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSale = function SvgSale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4746 12.175L12.5413 10.2417C12.4405 10.118 12.3134 10.0183 12.1692 9.9498C12.0251 9.88132 11.8675 9.84579 11.7079 9.84579C11.5484 9.84579 11.3908 9.88132 11.2466 9.9498C11.1025 10.0183 10.9754 10.118 10.8746 10.2417C9.97461 11.1417 12.0329 14.5834 11.1329 15.475C11.0282 15.5925 10.8998 15.6864 10.7562 15.7508C10.6126 15.8151 10.457 15.8484 10.2996 15.8484C10.1422 15.8484 9.98665 15.8151 9.84303 15.7508C9.69942 15.6864 9.57103 15.5925 9.46628 15.475L7.59961 13.55",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0996 10.8L14.1329 9.76669",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94116 15.9584L8.9745 14.925",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5496 8.11669C17.2124 8.11669 17.7496 7.57943 17.7496 6.91669C17.7496 6.25395 17.2124 5.71669 16.5496 5.71669C15.8869 5.71669 15.3496 6.25395 15.3496 6.91669C15.3496 7.57943 15.8869 8.11669 16.5496 8.11669Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4329 3.00003H11.6246C11.4482 3.0011 11.2739 3.03783 11.112 3.108C10.9502 3.17817 10.8042 3.28034 10.6829 3.40836L2.34958 12.3C2.23102 12.4251 2.13906 12.573 2.07924 12.7346C2.01943 12.8962 1.99301 13.0683 2.00158 13.2405C2.01014 13.4126 2.05352 13.5812 2.12909 13.7361C2.20466 13.891 2.31085 14.029 2.44125 14.1417L10.7746 21.4334C11.0269 21.6531 11.3547 21.7664 11.6889 21.7493C12.0231 21.7322 12.3376 21.5861 12.5662 21.3417L20.3746 13.0084C20.5994 12.7726 20.7248 12.4592 20.7246 12.1334V4.28336C20.7246 4.11413 20.6911 3.94656 20.6261 3.79032C20.5611 3.63407 20.4658 3.49223 20.3458 3.37295C20.2257 3.25367 20.0832 3.15931 19.9266 3.09531C19.7699 3.03131 19.6021 2.99893 19.4329 3.00003V3.00003Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSale;